/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

const BASE = "/cards";

export const CARDS_ROUTES = {
  BASE,
  ROOT: `${BASE}/*`,
  NAME: "Cards",
} as const;
